import React, { useRef } from 'react';
import { Dropdown } from 'components/molecules/dropdown';
import { Box, Flex, Text } from 'rebass/styled-components';
import { ChevronDown } from 'lucide-react';
import { Card } from 'components/atoms/Card';
import strings from 'strings';
import PropTypes from 'prop-types';
import MetricIcon from './MetricIcon';

export const Metrics = ({ selectedMetric, handleChange, groupedMetrics }) => {
  const ref = useRef(null);

  return (
    <Dropdown
      placement="bottom-start"
      ref={ref}
      trigger={
        <Flex
          sx={{
            alignItems: 'center',
            gap: '8px',
            cursor: 'pointer',
            p: '8px',
            borderRadius: '4px',
            border: '1px solid',
            borderColor: 'border.default',
            justifyContent: 'space-between',
          }}
        >
          <Flex sx={{ alignItems: 'center', gap: '8px' }}>
            <MetricIcon reportType={selectedMetric.reportType} />
            <Text
              sx={{
                color: 'text.main',
                fontFamily: 'Silka',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: '140%',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {selectedMetric.label}
            </Text>
          </Flex>
          <ChevronDown strokeWidth="1.5" sx={{ color: 'neutral.300' }} />
        </Flex>
      }
    >
      <Card
        sx={{
          zIndex: 1000,
          p: '0',
          py: '16px',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
        }}
        width="360px"
      >
        {Object.keys(groupedMetrics).map((product) => (
          <Box key={product}>
            <Text
              sx={{
                color: 'text.subtle',
                fontFamily: 'Silka',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: '16px',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                px: '16px',
                pb: '4px',
              }}
            >
              {strings.analytics.groups[product]}
            </Text>

            <Box>
              {groupedMetrics[product].map((metric) => (
                <Box
                  onClick={() => {
                    ref.current.closeDropdown();
                    handleChange({ target: { name: 'metric', value: metric } });
                  }}
                  key={metric.value}
                  sx={{
                    px: '16px',
                    py: '6px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: 'neutral.50',
                    },
                  }}
                >
                  <MetricIcon reportType={metric.reportType} />
                  <Text
                    sx={{
                      color: 'text.main',
                      fontFamily: 'Silka',
                      fontSize: '14px',
                      fontStyle: 'normal',
                      fontWeight: '400',
                      lineHeight: '140%',
                    }}
                  >
                    {metric.label}
                  </Text>
                </Box>
              ))}
            </Box>
          </Box>
        ))}
      </Card>
    </Dropdown>
  );
};

Metrics.propTypes = {
  selectedMetric: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  groupedMetrics: PropTypes.object.isRequired,
};
